export default __webpack_public_path__ + "static/media/WR_Supplier_White.a1a608c5.svg";